import {connect} from 'react-redux';
import {fetchPosts, search} from './../../actions';
import React, {Component} from 'react';
import PostsList from '../../components/PostsList/PostsList';
import utils from '../../utils/utils';

class PostsListController extends Component {
  static fetchData(dispatch, params) {
    return dispatch(fetchPosts(params));
  }

  render() {
    return (
      <PostsList {...this.props}/>
    );
  }
}

function getPageHeaderDivs(locale) {
  return {
    title: locale.main_page_title,
    description: locale.main_page_description
  };
}

function mapStateToProps(state) {
  const articlesContent = utils.parseItemsContent(state.posts.articles);
  const locale = state.locale.data;
  return {
    loading: state.posts.loading,
    numPages: state.posts.numPages,
    page: state.posts.page,
    tag: state.posts.tag,
    seo: state.posts.seo,
    title: state.posts.title,
    content: articlesContent,
    pageHeader: getPageHeaderDivs(locale),
    locale,
    isDatePickerEnabled: state.experiments.active.indexOf('enableSortByDateForReleaseNotes') > -1
  };
}

function mapDispatchToProps(dispatch) {
  return {
    search: params => dispatch(search(params))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PostsListController);



// WEBPACK FOOTER //
// ./containers/PostsList/PostsList.js